import { UserError } from "@/framework/errors/UserError";
import { getErrorMessageForDeveloper } from "@/framework/errors/getErrorMessageForDeveloper";

export function reportClientError(error: UserError): void {
  const payload = {
    error: error.details,
    message: getErrorMessageForDeveloper(error) || "internal error",
    location: window.location.href,
    path: window.location.pathname,
    referrer: document.referrer || undefined,
    userAgent: window.navigator.userAgent,
  };

  void fetch("/api/error-events", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).catch((requestError) => {
    console.error("Failed to report client error", requestError);
  });
}
